import React, { useCallback, useMemo } from "react";
import "./ShareToolsBar.css";

const IconX = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="18"
    height="18"
    aria-hidden="true"
    className="publications-share-tools__icon-svg"
  >
    <path
      fill="currentColor"
      d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
    />
  </svg>
);

/**
 * BNR-style share / utility strip: print | X | Facebook | LinkedIn | email.
 * Uses neutral tile backgrounds and icon color per design reference (not site theme colors).
 */
export default function ShareToolsBar({ pageTitle = "National Bank of Rwanda" }) {
  const url = typeof window !== "undefined" ? window.location.href : "";
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(pageTitle);

  const emailBody = encodeURIComponent(`${pageTitle}\n\n${url}`);

  const shareLinks = useMemo(
    () => ({
      x: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      email: `mailto:?subject=${encodedTitle}&body=${emailBody}`,
    }),
    [encodedUrl, encodedTitle, emailBody]
  );

  const handlePrint = useCallback(() => {
    if (typeof window !== "undefined") window.print();
  }, []);

  return (
    <div className="publications-share-tools" role="group" aria-label="Page tools and sharing">
      <button
        type="button"
        className="publications-share-tools__btn"
        onClick={handlePrint}
        aria-label="Print this page"
      >
        <i className="fa fa-print" aria-hidden="true" />
      </button>
      <span className="publications-share-tools__divider" aria-hidden="true" />
      <a
        href={shareLinks.x}
        target="_blank"
        rel="noopener noreferrer"
        className="publications-share-tools__btn"
        aria-label="Share this page on X"
      >
        <IconX />
      </a>
      <a
        href={shareLinks.facebook}
        target="_blank"
        rel="noopener noreferrer"
        className="publications-share-tools__btn"
        aria-label="Share this page on Facebook"
      >
        <i className="fab fa-facebook-f" aria-hidden="true" />
      </a>
      <a
        href={shareLinks.linkedin}
        target="_blank"
        rel="noopener noreferrer"
        className="publications-share-tools__btn"
        aria-label="Share this page on LinkedIn"
      >
        <i className="fab fa-linkedin-in" aria-hidden="true" />
      </a>
      <a href={shareLinks.email} className="publications-share-tools__btn" aria-label="Email this page">
        <i className="fa fa-envelope" aria-hidden="true" />
      </a>
    </div>
  );
}
